import { ThunkAction } from 'redux-thunk'
import { loadProfile } from '.'
import { RootState } from '..'
import { userApi } from '../../apis'
import { UserEntity, UserFilter, UserTypeEntity } from '../../models'
import {
  SET_SELECTED_USER,
  SET_USERS,
  SET_USERS_LOADED,
  SET_USER_FILTER,
  SET_USER_TYPES,
  SET_USER_TYPES_LOADED,
  UserAction,
} from '../types'

export const setUserFilter = (userFilter: UserFilter): UserAction => ({
  type: SET_USER_FILTER,
  payload: userFilter,
})

export const setSelectedUser = (selectedUser?: UserEntity): UserAction => ({
  type: SET_SELECTED_USER,
  payload: selectedUser,
})

export const setUsers = (users: UserEntity[]): UserAction => ({
  type: SET_USERS,
  payload: users,
})

export const setUserTypes = (userTypes: UserTypeEntity[]): UserAction => ({
  type: SET_USER_TYPES,
  payload: userTypes,
})

export const setUserTypesLoaded = (loaded: boolean): UserAction => ({
  type: SET_USER_TYPES_LOADED,
  payload: loaded,
})

export const setUsersLoaded = (loaded: boolean): UserAction => ({
  type: SET_USERS_LOADED,
  payload: loaded,
})

export const loadUsers = (): ThunkAction<void, RootState, null, UserAction> => {
  return async (dispatch) => {
    try {
      dispatch(setUsersLoaded(false))
      const resp = await userApi.getUsers()
      dispatch(setUsers(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await userApi.getUsers()
        dispatch(setUsers(resp.data.data))
      }
    } finally {
      dispatch(setUsersLoaded(true))
    }
  }
}

export const loadUserTypes = (): ThunkAction<
  void,
  RootState,
  null,
  UserAction
> => {
  return async (dispatch) => {
    try {
      dispatch(setUserTypesLoaded(false))
      const resp = await userApi.getUserTypes()
      dispatch(setUserTypes(resp.data.data))
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await userApi.getUserTypes()
        dispatch(setUserTypes(resp.data.data))
      }
    } finally {
      dispatch(setUserTypesLoaded(true))
    }
  }
}
